import { Pipe, PipeTransform } from '@angular/core';
import { PlanWithSectionsAnalytiquesModel } from 'src/graphql/generated-types';

@Pipe({
    name: 'sectionLabelFromPlan',
    standalone: false
})
export class SectionLabelFromPlanPipe implements PipeTransform {

    transform(plan: PlanWithSectionsAnalytiquesModel): string {
        return plan.ListeSection?.anyType?.find(e => +e?.IdSection === +plan.IdSectionAnalytique)?.LibelleSection || '';
    }
}
